import { render, staticRenderFns } from "./oneLeft.vue?vue&type=template&id=fc512216&"
import script from "./oneLeft.vue?vue&type=script&lang=js&"
export * from "./oneLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports